import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierProcurementConditionResource } from "@exonn/js-sdk";

// Lieferantenkonditionen: пункт меню «Einkauf» и вкладка «Lieferantenkonditionen» у поставщика.
export const module: ModuleOptions<SupplierProcurementConditionResource> = {
  resource: ResourceEnum.SupplierProcurementCondition,
  bigIcon: <i className="icon-20-suppliers" />,
  smallIcon: <i className="icon-15-suppliers" />,

  tabs: {
    edit: {
      includes: ["supplier"],
      getTitle: (resource, t) =>
        [
          resource.supplier?.number,
          resource.procurement_type &&
            t(`procurement-type.${resource.procurement_type}`),
        ]
          .filter(Boolean)
          .join(" · "),
    },
  },
};
